<template>
  <v-card
    class="box"
    max-width="500"
  >
    <v-img
      height="175"
      :src="picUri"
    ></v-img>

    <div class="px-4 py-3">
      {{ title }}
    </div>
  </v-card>
</template>

<style scoped>
.box {
  border: 0;
  height: 65vh;
  max-height: 500px;
  font-size: 20px;
  position: absolute;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

  /* Enable transition on card change */
  /*.box:not(:hover) {
    transition: transform .3s;
  }*/

  /* Simulate the stack effect in cards */
/*  .box:last-child {
    margin-top: -32px;
    transform: scale(1.05);
  }
  .box:first-child:not(:last-child) {
    margin-top: 32px;
    transform: scale(.95);
  }*/
</style>

<script>
export default {
  name: 'CardsGameCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    pic: {
      type: String,
      default: 'https://cdn.vuetifyjs.com/images/cards/cooking.png',
    },
  },
  computed: {
    picUri() {
      if (this.pic) {
        return this.$imageUrl(this.pic, 'cards');
      }

      return '';
    },
  },
};
</script>
